import userService from '@/api/user'
import { setToken, setUser, getUserId, setUserId, clearAuth } from '@/utils/auth'
import userTypes from './types/user'

const state = {
  token: '',
  roles: [],
  userId: '',
  user: null
}

const actions = {
  [userTypes.LOGIN] ({ commit }, { userName, password, nonce, sessionId }) {
    return new Promise((resolve, reject) => {
      userService.login({ userName, password, nonce, sessionId }).then(res => {
        const data = res.data
        commit('SET_TOKEN', data)
        setToken(data.bearerToken)
        setUserId(data.userId)
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  [userTypes.GET_USER_INFO] ({ commit }) {
    const userId = getUserId()
    return new Promise((resolve, reject) => {
      userService.getUserInfo(userId).then(res => {
        const user = res.data
        commit('SET_USER', user)
        setUser(user)
        resolve(user)
      }).catch(err => reject(err))
    })
  },
  [userTypes.GET_MENU] ({ commit }, { Grade }) {
    return new Promise((resolve, reject) => {
      userService.getMenuInfo({ Grade }).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  [userTypes.CHANGE_PWD] ({ commit }, stationGroup) {
    return new Promise((resolve, reject) => {
      userService.changePwd(stationGroup).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  [userTypes.LOGOUT] ({ commit }) {
    return new Promise((resolve, reject) => {
      userService.logout().then(() => {
        commit('LOGOUT')
        resolve()
      }).catch(err => reject(err))
    })
  },
  [userTypes.Get_PUBLICKEY] ({ commit }) {
    return new Promise((resolve, reject) => {
      userService.getPublicKey().then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  [userTypes.GET_NESTED_FLOOR_NAV] ({ commit }, params) {
    return new Promise((resolve, reject) => {
      userService.getNestedFloorNav(params).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  // 水位设置
  [userTypes.STATION_WARN_WATER_INFO] ({ commit }, params) {
    return new Promise((resolve, reject) => {
      userService.getStationWaterInfo(params).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  [userTypes.SAVE_STATION_WARN_WATER_INFO] (_, preventGroup) {
    return new Promise((resolve, reject) => {
      userService.saveStationWaterInfo(preventGroup).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  // 水位设置河道
  [userTypes.GET_RIVER_LIST_INFO] ({ commit }, params) { // 获取列表
    return new Promise((resolve, reject) => {
      userService.getRiverListInfo(params).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  [userTypes.SAVE_RIVER_LIST_INFO] (_, preventGroup) { // 保存列表
    return new Promise((resolve, reject) => {
      userService.saveRiverListInfo(preventGroup).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  // 水位时间段设置新增
  [userTypes.BACK_STATION_WARN_WATER_INFO] (_, preventGroup) {
    return new Promise((resolve, reject) => {
      userService.getBackStationWaterInfo(preventGroup).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  [userTypes.BATCH_SAVE_STATION_WARN_WATER_INFO] (_, preventGroup) {
    return new Promise((resolve, reject) => {
      userService.batchSaveStationWaterInfo(preventGroup).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  // 重置密码
  [userTypes.RESET_PWD] ({ commit }, params) {
    return new Promise((resolve, reject) => {
      userService.resetPwd(params).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  },
  [userTypes.SAVE_FLOOR_NAV] (_, ids) {
    return new Promise((resolve, reject) => {
      userService.save_floor_nav(ids).then(res => {
        resolve(res.data)
      }).catch(err => reject(err))
    })
  }
}

const mutations = {
  SET_TOKEN (state, authInfo) {
    state.token = authInfo.bearerToken
    state.userId = authInfo.userId
  },
  SET_USER (state, user) {
    state.user = user
    state.roles = [user.role]
  },
  LOGOUT (state) {
    state.user = null
    state.roles = []
    state.token = ''
    state.userId = ''
    clearAuth()
  }
}

export default {
  state,
  actions,
  mutations
}
